import script from "./MenuView.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuView.vue?vue&type=script&setup=true&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=92d460bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92d460bc"]])

export default __exports__